/**
 * Card do plugin WAHA no grid.
 */

import React from 'react';
import { IconBrandWhatsapp } from '@tabler/icons-react';
import useWahaStatus from './useStatus';

const WahaCard = ({ agentId, context }) => {
  const status = useWahaStatus(agentId);

  const handleConnect = (e) => {
    e.stopPropagation();
    if (context?.onConnect) context.onConnect('whatsapp_waha');
  };

  const handleConfigure = (e) => {
    e.stopPropagation();
    if (context?.onSelect) context.onSelect('whatsapp_waha');
  };

  const cardClass = [
    'channel-card',
    status.isConnected && 'channel-card--connected',
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClass}>
      <div
        className="channel-card__icon"
        style={{ background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)', color: '#fff' }}
      >
        <IconBrandWhatsapp size={22} />
      </div>

      <div className="channel-card__body">
        <h5 className="channel-card__name">WhatsApp Não Oficial</h5>
        <p className="channel-card__description">
          Conexão via QR Code.
        </p>
        {!status.isLoading && status.isConnected && status.summary && (
          <p className="channel-card__summary">{status.summary}</p>
        )}
        {!status.isLoading && status.raw && !status.isConnected && (
          <p className="channel-card__summary" style={{ color: '#d97706' }}>
            {status.statusLabel}
          </p>
        )}
      </div>

      <div className="channel-card__footer">
        {status.isConnected ? (
          <>
            <span className={`channel-card__status-pill channel-card__status-pill--${status.statusVariant}`}>
              {status.statusLabel}
            </span>
            <button
              type="button"
              className="channel-card__cta"
              onClick={handleConfigure}
              style={{ background: '#374151' }}
            >
              Gerenciar
            </button>
          </>
        ) : status.raw ? (
          <>
            <span className={`channel-card__status-pill channel-card__status-pill--${status.statusVariant}`}>
              {status.statusLabel}
            </span>
            <button type="button" className="channel-card__cta" onClick={handleConfigure}>
              Configurar
            </button>
          </>
        ) : (
          <>
            <span />
            <button type="button" className="channel-card__cta" onClick={handleConnect}>
              Conectar
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default WahaCard;
